import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=560a33b1&scoped=true"
import script from "./RequestDialog.vue?vue&type=script&lang=js"
export * from "./RequestDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestDialog.vue?vue&type=style&index=0&id=560a33b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a33b1",
  null
  
)

export default component.exports